import React from "react";
import PropTypes from "prop-types";

// styles
import * as styles from "./InfoCard.module.css";

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      iconAlt: PropTypes.string,
    })
  ).isRequired,
  backgroundColor: PropTypes.string,
  columns: PropTypes.oneOf([3, 4]),
  iconAlign: PropTypes.oneOf(["left", "center"]),
};

const defaultProps = {
  backgroundColor: "#555A83",
  columns: 4,
  iconAlign: "left",
};

const InfoCard = ({ cards, backgroundColor, columns, iconAlign }) => {
  return (
    <div className={styles.cardsWrapper}>
      <div
        className={`${styles.cardsGrid} ${
          columns === 3 ? styles.threeColumns : styles.fourColumns
        }`}
      >
        {cards.map((card, index) => (
          <div
            key={index}
            className={`${styles.card} ${
              iconAlign === "center" ? styles.iconCenter : ""
            } ${!card.icon ? styles.noIcon : ""}`}
            style={{ backgroundColor: backgroundColor }}
          >
            {/* Icon - only render if exists */}
            {card.icon && (
              <div className={styles.cardIcon}>
                <img
                  src={card.icon}
                  alt={card.iconAlt || card.title}
                  className={styles.iconImage}
                />
              </div>
            )}

            {/* Title */}
            <h3 className={styles.cardTitle}>{card.title}</h3>

            {/* Description */}
            {card.description && (
              <p className={styles.cardDescription}>{card.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

InfoCard.propTypes = propTypes;
InfoCard.defaultProps = defaultProps;

export default InfoCard;
